import styled from '@emotion/styled';

const PrimaryButton = styled.button`
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}` : '16px')};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : '#7F38E9')};
  padding: 8px 16px;
  color: ${(props) => (props.color ? props.color : '#fff')};
  border: 1px solid ${(props) => (props.backgroundColor ? props.backgroundColor : '#7F38E9')};
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  transition: all 0.1s linear;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: ${(props) => (props.width ? `${props.width}` : 'auto')};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    opacity: 0.95;
  }
  &:active {
    transform: scale(0.95);
  }
  &:disabled {
    background-color: #dfcdfa;
    opacity: 0.5; 
    cursor: not-allowed;
    border: 1px solid #dfcdfa;
  }
`;

export default PrimaryButton;
